<section class="stc-ganadores-opt" style="background-image: url(/assets/images/soteo-oportuno/banner-ganadores-so3-vf.jpg);">
    <div class="container">
        <div class="row">

            <div class="col-md-6 my-auto" >
                <h1 style="color: #fff;">
                    CONOCE
                    <span class="text d-block" style="background-color: #712182;">
                         A NUESTROS
                    </span>
                    GANADORES 
                    <span class="paragraph d-block">
                        3° SORTEO OPORTUNO
                    </span>
                </h1>
            </div>

            <div class="col-md-6 my-auto">
                <img src="/assets/images/soteo-oportuno/winner-vf.png"  class="img-fluid" width="350" alt="Ganadores Tercer Sorteo Oportuno 2025">
            </div>

        </div>
    </div>
</section>


<section class="stc-winners-opt lealtad">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 style="background-color: #e63020 !important;">
                   LISTA OFICIAL DE GANADORES
                    <span class="d-block">
                         3° SORTEO OPORTuNO 2025
                    </span>
                </h2>
            </div>
            <div class="col-md-12 ">
                <div class=" text-center"  style="overflow-x: auto;">
                    
                    <table class="table table-striped ">
                       
                        <thead class="text-center">
                            <tr class="text-center">
                                <th class = "border-none" colspan="4">Compradores</th>
                                <th class = "border-none" colspan="3">Colaboradores</th>
                            </tr>
                            <tr class="text-center cols">
                                <th scope="col"><span>No. DE PREMIO</span></th>
                                <th scope="col"><span>nombre</span></th>
                                <th scope="col"><span>VALOR</span></th>
                                <th scope="col"><span>NÚMERO DE BOLETO</span></th>
                                <th scope="col"><span>NOMBRE</span></th>
                                <th scope="col"><span>VALOR</span></th>
                                <th scope="col"><span>NÚMERO DE BOLETO </span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center first">
                                <td>1</td>
                                <td>Fernando G. M.</td>
                                <td> $200,000.00 </td>
                                <td>180724</td>
                               <td>Fernando G. M.</td>
                                <td>$100,000.00</td>
                                <td>POR VENDER EL BOLETO 180724</td>
                            </tr>
                            <tr class="text-center second">
                                <td>2</td>
                                <td>Daniel G. D.</td>
                                <td> $150,000.00</td>
                                <td>273721</td>
                                <td>María G. C.  </td>
                                <td>$50,000.00</td>
                                <td>POR VENDER EL BOLETO 273721</td>
                            </tr>

                            <tr class="text-center first">
                                <td>3</td>
                                <td>Fabiola D. G.</td>
                                <td>$100,000.00</td>
                                <td>314373</td>
                                <td>Franco Alexandro G. S.</td>
                                <td>$25,000.00</td>
                                <td>POR VENDER EL BOLETO 314373</td>
                            </tr>

                            <tr class="text-center second">
                                <td>4</td>
                                <td>Carlos P. G.</td>
                                <td>$50,000.00</td>
                                <td>190510</td>
                                <td>Renata P. C.</td>
                                <td>$15,000.00</td>
                                <td>POR VENDER EL BOLETO 190510</td>
                            </tr>

                            <tr class="text-center first">
                                <td>5</td>
                                <td>Rodrigo P. U.</td>
                                <td>$25,000.00</td>
                                <td>354907</td>
                                <td>Rodrigo P. L.</td>
                                <td>$5,000.00</td>
                                <td>POR VENDER EL BOLETO 354907</td>
                            </tr>


                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-12">
                <p class="font-bold">
                    SORTEO ANÁHUAC MAGNO 2025
                </p>

                <p class="font-bold">
                    3ER. SORTEO OPORTUNO.
                </p>

                <p>
                    El Sorteo Anáhuac celebró el día viernes 17 de octubre de 2025, a las 11:15 horas, el Tercer Sorteo Acumulado Especial de Compradores y Colaboradores Oportunos del SORTEO ANAHUAC MAGNO, en la Universidad Anáhuac México Campus Sur con domicilio en la Avenida Universidad Anáhuac no. 46 Col. Lomas Anáhuac. C.P. 52786 Huixquilucan, Estado de México con la presencia del <strong class="font-bold">C. Rubí Guadalupe Guerrero García,</strong> Inspector de la Secretaría de Gobernación, para dar fe de la legalidad del evento.
                </p>
                <p>
                    De acuerdo con lo establecido en el Permiso No.  <strong  class="font-bold">20250046PS07 </strong> otorgado por la Secretaría de Gobernación a Sorteo Anáhuac, A.C., los resultados de los ganadores, así como los nombres de los colaboradores que se han hecho acreedores a un premio por haber vendido los boletos del premio uno al cinco, han de ser publicados de forma posterior al evento del sorteo en la página de internet https://www.sorteoanahuac.mx/ y nuestras redes sociales a partir del día 18 de octubre de 2025 y de acuerdo a lo registrado ante SEGOB, solo aparecerá el nombre propio de los ganadores, completándose con las iniciales de cada uno de los apellidos, y adicionalmente, se publicará la lista con los  nombres completos de los ganadores en las Instalaciones de la Universidad Anáhuac México Campus Norte, ubicada en la Av. Universidad no. 46 Colonia Lomas de Anáhuac, CP. 52786, Huixquilucan Estado de México.
                </p>
                <p>
                    Los premios mayores a 1,500 (UMA) $169,710.00 (Ciento sesenta y nueve mil setecientos diez pesos 00/100 m.n.) se solicitará la presencia de un inspector de la DGJS para la entrega de los mismos, conforme al siguiente calendario de fechas: 31 de octubre de 2025 a las 12:00 horas. Entrega del Premio 1 de Comprador del Tercer Sorteo Acumulado Especial de Compradores y Colaboradores Oportunos del SORTEO ANAHUAC MAGNO. En las instalaciones de la Universidad Anáhuac México Campus Norte con domicilio en Av. Universidad Anáhuac no. 46 Huixquilucan, Estado de México. C.P. 52786.
                </p>
                <p>
                    Los premios serán pagados y entregados de conformidad con lo establecido en las bases de Sorteo, los premios menores a 1,500 (UMA) $169,710.00 (Ciento sesenta y nueve mil setecientos diez pesos 00/100 m.n.) se realizará dentro de los 20 (veinte) días hábiles contados a partir de la celebración del sorteo, en Avenida Universidad Anáhuac N° 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México, piso 7 del edificio de Biblioteca, en horario de lunes a jueves de 10:00 a 18:00 hrs. y los viernes de 10:00 a 14:00 hrs. 
Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 2137.

                </p>

                <p>
                    Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses) y CURP; el nombre completo escrito en el boleto debe corresponder exactamente con el del talón o con el registro en la APP del Sorteo Anáhuac y su identificación oficial.
En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.

                </p>
            </div>
            
        </div>
    </div>
</section>